import { makeAutoObservable } from 'mobx'
import { Cartographic, Math, ScreenSpaceEventHandler, ScreenSpaceEventType, WebMapServiceImageryProvider } from '@cesiumgs/cesium-analytics'
import { getCenterPosition } from '@/utils/rightNavCtrl'
import { getPositionPUN } from '@/service/rightNavCtrl'

export class MapFeatureStore {
  constructor() {
    makeAutoObservable(this)
  }

  public layerType = ''

  public addImageLayer = async (cviewer: any) => {
    const lnglat = getCenterPosition(cviewer)
    const response = await getPositionPUN(lnglat) || {}
    // return response
    if (
      response.data
      && response.data.returnCode === '200'
      && response.data.contents
      && response.data.contents.result
      && response.data.contents.result.jusoList
      && response.data.contents.result.jusoList.jusoList
      && response.data.contents.result.jusoList.jusoList.addrPnu
    ) {
      this.addSpecifiedStore(response.data.contents.result.jusoList.jusoList.addrPnu, cviewer)
    }
  }

  public addSpecifiedStore = (str: string, cviewer: any) => {
    const citycode = str.slice(0, 2)
    const newlayserstr = `LSMD_CONT_LDREG_${citycode}_202205`
    cviewer.imageryLayers._layers.forEach((item: any) => {
      if (item._imageryProvider._layers === this.layerType) {
        cviewer.imageryLayers.remove(item)
      }
    })
    const providerLayer = new WebMapServiceImageryProvider({
      url: window.SystemConfig.rightNavCtrlConfig.geoserverBaseWMSUrl,
      layers: newlayserstr,
      parameters: {
        service: 'WMS',
        format: 'image/png',
        transparent: true,
      },
    })
    cviewer.imageryLayers.addImageryProvider(providerLayer)
    const handler = new ScreenSpaceEventHandler(cviewer.canvas)

    handler.setInputAction((e: any) => {
      const ray = cviewer.camera.getPickRay(e.position)
      const position = cviewer.scene.globe.pick(ray, cviewer.scene)
      const cartographic = Cartographic.fromCartesian(position)
      const lng = Math.toDegrees(cartographic.longitude)
      const lat = Math.toDegrees(cartographic.latitude)
      // changeCssStore({ pos: { lng, lat }, name: newlayserstr })
    }, ScreenSpaceEventType.LEFT_CLICK)

    handler.setInputAction(() => {
      handler && handler.destroy()
    }, ScreenSpaceEventType.RIGHT_CLICK)
    // setLayerType(newlayserstr)
    this.layerType = newlayserstr
  }

  // const changeCssStore = async (lnglat: any) => {
  //   const response: any = await getWMSPosPUN({ ...lnglat })
  //   if (Array.isArray(response.features) && response.features.length > 0) {
  //     if (window.cviewer.dataSources.getByName('polygon').length > 0) {
  //       window.cviewer.dataSources.getByName('polygon').forEach((item: any) => {
  //         window.cviewer.dataSources.remove(item)
  //       })
  //     }

  //     const smcPromise = GeoJsonDataSource.load(response.features[0], {
  //       clampToGround: true,
  //       stroke: Color.fromCssColorString('red').withAlpha(0.5),
  //       fill: Color.fromCssColorString('red').withAlpha(0.5),
  //       strokeWidth: 2,
  //     })
  //     smcPromise.then((data2) => {
  //       const data = response.features[0]
  //       data2.name = 'polygon'
  //       window.cviewer.dataSources.add(data2)
  //       setClickPlotPolygon([data])
  //     })

  //     if (response.features[0].geometry.type === 'MultiPolygon') {
  //       const thePlotArr = response.features[0].geometry.coordinates[0][0]
  //       const positionArr = []
  //       const pointArr: any = []
  //       const pos = {
  //         type: 'Feature',
  //         properties: {},
  //         geometry: {
  //           type: 'Polygon',
  //           coordinates: response.features[0].geometry.coordinates[0],
  //         },
  //       }
  //       positionArr.push(pos)
  //       response.features[0].geometry.coordinates[0][0].forEach((child: any) => {
  //         pointArr.push(child[0])
  //         pointArr.push(child[1])
  //       })
  //       setClickPlotPolygon(positionArr)
  //       const thePlotArrCartesian3: any = []
  //       thePlotArr.forEach((item: any) => {
  //         const cartographic = Cartographic.fromDegrees(item[0], item[1])
  //         const cartesian3 = window.cviewer.scene.globe.ellipsoid.cartographicToCartesian(cartographic)
  //         thePlotArrCartesian3.push(cartesian3)
  //       })

  //       const lnglatArr = worldToLngLat(window.cviewer, thePlotArrCartesian3)
  //       const clockwiseRing = turf.lineString(lnglatArr)
  //       const isclock = turf.booleanClockwise(clockwiseRing)
  //       if (isclock) {
  //         const newEvt = thePlotArrCartesian3.reverse()
  //         clickPlotPosition = newEvt
  //       }
  //       else {
  //         clickPlotPosition = thePlotArrCartesian3
  //       }
  //       clickPlotPosition.pop()
  //     }
  //   }
  // }
}
